<div
  class="navbar-top"
  [ngClass]="fuseConfig.layout.navbar.secondaryBackground"
>
  <div class="logo">
    <img class="logo-icon" src="assets/images/logos/logo.png" />
    <span class="logo-text secondary-text">IDEMPIER</span>
  </div>

  <div class="buttons">
    <button mat-icon-button fxHide.lt-lg>
      <mat-icon class="secondary-text">home</mat-icon>
    </button>

    <button mat-icon-button fxHide.lt-lg>
      <mat-icon class="secondary-text">apps</mat-icon>
    </button>

    <button
      mat-icon-button
      class="toggle-sidebar-folded"
      (click)="toggleSidebarFolded()"
      fxHide.lt-lg
    >
      <mat-icon class="secondary-text">menu</mat-icon>
    </button>
  </div>
</div>

<div
  class="navbar-scroll-container"
  [ngClass]="fuseConfig.layout.navbar.primaryBackground"
  fusePerfectScrollbar
  [fusePerfectScrollbarOptions]="{ suppressScrollX: true }"
>
  <div
    class="user"
    fxLayout="column"
    [ngClass]="fuseConfig.layout.navbar.secondaryBackground"
  >
    <!--<div class="h3 username">{{ account$.nombre }}</div>-->
    <div class="email">{{ account$.username }}</div>
    <div
      class="avatar-container"
      [ngClass]="fuseConfig.layout.navbar.primaryBackground"
    >
      <img class="avatar" src="assets/images/avatars/Velazquez.jpg" />
    </div>
  </div>

  <div fxLayout="row">
    <div fxFlex="30">
      <button mat-icon-button fxHide.lt-lg [matMenuTriggerFor]="menuLeft">
        <mat-icon>settings</mat-icon>
      </button>
      <mat-menu #menuLeft="matMenu">
        <button mat-m [routerLink]="['/perfil-facturacion']">
          <mat-icon>label</mat-icon>
          <span>Firma Electronica</span>
        </button>
        <button mat-menu-item *ngIf="showMenu" [routerLink]="['/parametros']">
          <mat-icon>label</mat-icon>
          <span>Perfil Tributario</span>
        </button>
        <button mat-menu-item *ngIf="showMenu" [routerLink]="['/matrices']">
          <mat-icon>label</mat-icon>
          <span>Establecimientos</span>
        </button>
        <button
          mat-menu-item
          *ngIf="showMenu && showBienes"
          [routerLink]="['/catalogo-bienes']"
        >
          <mat-icon>label</mat-icon>
          <span>Catalogo Bienes</span>
        </button>
        <button
          mat-menu-item
          *ngIf="showMenu && showServicios"
          [routerLink]="['/catalogo-servicios']"
        >
          <mat-icon>label</mat-icon>
          <span>Catalogo Servicios</span>
        </button>
        <button mat-menu-item *ngIf="showMenu">
          <mat-icon>label</mat-icon>
          <span>Impuestos</span>
        </button>
        <button
          mat-menu-item
          *ngIf="showMenu"
          [routerLink]="['/list-contactos']"
        >
          <mat-icon>label</mat-icon>
          <span>Contactos</span>
        </button>
        <button mat-menu-item *ngIf="showMenu">
          <mat-icon>label</mat-icon>
          <span>Usuarios</span>
        </button>
        <button mat-menu-item *ngIf="showMenu">
          <mat-icon>label</mat-icon>
          <span>Modulos</span>
        </button>
        <button mat-menu-item>
          <mat-icon>label</mat-icon>
          <span>Sistemas</span>
        </button>
      </mat-menu>
    </div>

    <span
      (click)="openSeleccionarEstablecimiento()"
      fxFlex="50"
      fxFlexOffset="15"
      class="cambiar-logo-base establecimiento-label pointer"
      >Local</span
    >
    <div fxFlex="30" fxFlexOffset="15">
      <button mat-icon-button fxHide.lt-lg (click)="onSubmenu()">
        <mat-icon
          *ngIf="
            productosPedidosPendientes && productosPedidosPendientes.length > 0
          "
          matBadge="{{ productosPedidosPendientes.length }}"
          matBadgeColor="warn"
          >more_vert</mat-icon
        >
        <mat-icon
          *ngIf="
            productosPedidosPendientes && productosPedidosPendientes.length <= 0
          "
          >more_vert</mat-icon
        >
      </button>
    </div>
  </div>

  <div class="navbar-content">
    <div
      class="text-center"
      *ngIf="establecimientoSelected$ | async as establecimiento"
    >
      <span>{{ establecimientos$.tipo }}</span>
      <br />
      <span
        >[ {{ establecimientos$.numero }} -
        {{ establecimientos$.cajas[0].numero }} ]</span
      >
      <br />
      <span
        >{{ establecimientos$.parroquia.canton.cantonName }} -
        {{ establecimientos$.nombreLocal }}</span
      >
    </div>
    <fuse-navigation class="material2" layout="vertical"></fuse-navigation>
  </div>
</div>
